// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2DJdu","buttons":"PendingPaymentAlert_buttons__144m-"};